var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWeatherLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 39,
    viewBox: "0 0 2 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 0.5,
    x2: 0.999998,
    y2: 38.5,
    stroke: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherLine);
export default __webpack_public_path__ + "static/media/icon-weather-line.b1d793b067762e0277bb0b05c5df1bd0.svg";
export { ForwardRef as ReactComponent };